import e from "./IconBase-vue-script.js";
//#region src/IconBase/IconBase.vue
var t = e;
//#endregion
export { t as default };
